import { DailyActivitiesState } from '@/common/types/student';
import { getDailies } from '@/game/GameComponents/PhaserGame/GameInstance';
import { EventBus } from '../EventBus';
import GAME_EVENTS from './gameEventsDef';

export interface Reward {
  rewardType?: RewardType;
  dailyActivity?: string;
  rewardCompleteLabel: string;
  autoAccept: boolean;
  rubies: number;
  cosmetics?: number[];
  masteryGame?: string;
}

export enum RewardType {
  DAILY_MINIGAME = 'DAILY_MINIGAME',
  DAILY_DUEL = 'DAILY_DUEL',
  MINIGAME_MASTERY = 'MINIGAME_MASTERY',
}

export class RewardsManager {
  private static rewardQueue: Reward[] = [];

  static QueueReward(reward: Reward) {
    this.rewardQueue.push(reward);
    EventBus.emit(GAME_EVENTS.REWARD_EARNED, reward);
  }

  static CheckRewards() {
    // Check dailies.
    const dailies = getDailies();

    // Daily minigames.
    const numUnclaimedDailyMinigameRewards =
      dailies.minigames.numCompletedMinigames -
      dailies.minigames.numRewardsClaimed;

    for (var i = 0; i < numUnclaimedDailyMinigameRewards; i++) {
      const reward = this.GenerateDailyMinigameReward();
      this.QueueReward(reward);
    }

    // Daily duel.
    if (
      dailies.duel.shouldCompleteDuel &&
      dailies.duel.hasCompletedDuel &&
      !dailies.duel.hasClaimedDuelReward
    ) {
      this.QueueReward(this.GenerateDailyDuelReward());
    }
  }

  static GenerateDailyMinigameReward(): Reward {
    return {
      rewardType: RewardType.DAILY_MINIGAME,
      rewardCompleteLabel: 'Daily Minigame Completed!',
      rubies: 50,
      cosmetics: [],
      autoAccept: true,
    };
  }

  static GenerateDailyDuelReward(): Reward {
    return {
      rewardType: RewardType.DAILY_DUEL,
      rewardCompleteLabel: 'Daily Duel Completed!',
      rubies: 50,
      cosmetics: [],
      autoAccept: true,
    };
  }

  static GenerateMasteryReward(minigame: string): Reward {
    return {
      rewardType: RewardType.MINIGAME_MASTERY,
      cosmetics: [],
      rubies: 0,
      rewardCompleteLabel: 'Minigame Mastered',
      masteryGame: minigame,
      autoAccept: true,
    };
  }

  static GetNextReward() {
    return this.rewardQueue.shift();
  }

  static HasRewardAvailable(): boolean {
    return this.rewardQueue.length > 0;
  }

  static getTotalDailyProgress(dailies: DailyActivitiesState) {
    if (!dailies) return 0;
    const { shouldCompleteDuel } = dailies.duel;
    const targetDailies =
      dailies.minigames.targetNumMinigames + (shouldCompleteDuel ? 1 : 0);
    const numCompletedDailies =
      dailies.minigames.numCompletedMinigames +
      (dailies.duel.hasCompletedDuel ? 1 : 0);
    return numCompletedDailies / targetDailies;
  }
}
